import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-b from-[#0B0F14] via-[#0A241C] to-[#071A14] flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-[#121923] border border-red-600/30 rounded-xl p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-red-600/20 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-8 h-8 text-red-500" />
            </div>
            
            <h2 className="text-2xl font-heading font-bold text-red-400 mb-2">
              Oops! Something went wrong
            </h2>
            
            <p className="text-foreground/60 mb-6">
              Don't worry - your progress is saved. Let's get you back on track.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="bg-[#0F1419] rounded p-3 mb-6 text-left">
                <p className="text-xs text-red-400 font-mono break-words">
                  {this.state.error.toString()}
                </p>
              </div>
            )}
            
            <button
              onClick={() => window.location.href = '/app/play'}
              className="w-full py-3 bg-[#C9A227] hover:bg-[#E1C25B] text-[#0B0F14] rounded-lg font-bold transition-colors flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-5 h-5" />
              Return to Platform
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
